import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'CVR107%改善 - システム改修なしでECサイトのUX/UIを最新化',
  title1: `CVR107%改善 - システム改修なしでECサイトのUX/UIを最新化`,
  introduction_text:
    'エンタメECサイト「セブンネットショッピング」のサイト分析とUI改善を担当しました。このサイトは、本・コミック、雑誌、電子書籍、CD、DVD、アーティストグッズなどを扱うECサイトです。弊社は数年単位で継続的なご支援をさせていただいており、直近の「推し活倶楽部」プロジェクトでもデザインから開発まで実施しました。',
  company: '株式会社セブンネットショッピング',
  tag1text: 'UX/UI改善',
  tag1src: '/cases/uxui-improvement/',
  tag2text: 'flamingo',
  tag2src: '/cases/flamingo/',
  industryTagText: '小売/流通/卸',
  industryTagSrc: '/cases/retail/',
  color: '#222222',
  background: 'linear-gradient(83.97deg, #DEDFFF 0%, #E9FAEB 34.76%, #FCF9CD 65.69%, #FBD4E8 100%)',
  staff1:
    '株式会社セブンネットショッピング\n営業本部 マーケティング＆プロモーション部 統括マネージャー村上陽祐さん・スペシャリスト壁巣翔子さん',
  image: '/images/img/cases/sevennet/top.png',
  alt: 'CVR107%改善 - システム改修なしでECサイトのUX/UIを最新化',
  // imgClass: 'fv_img_adjust1',
}

// プロジェクト概要
export const overviewTitle = 'システム改修不要のUI改善ツール“flamingo”でご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: '2021年の流行語大賞にもノミネートされた「推し活」とは、自分が好きなアイドルやアニメキャラなどを対象に、そのグッズを購入したりライブなどのイベントに参加したりする（＝推す）活動全般を指す言葉です。',
  },
  {
    text: '株式会社セブンネットショッピングによるエンタメECサイト「セブンネットショッピング」は、同サイト内で推し活をしているユーザーに向けたスペシャルページ「推し活倶楽部」を展開。その一環として、2022年5月からセブンネットショッピングのスマートフォンサイトを自分の好きな「推し色」に変更できる期間限定企画を開始したところ、お客さまから大好評を博してコンバージョンレート（以下、CVR）が向上するという結果に。さらには同年8月からはお客さまからの要望を受け、新色を加えて継続的な機能となりました。アイスリーデザインは「セブンネットショッピング」のUI改善をきっかけとして、現在までグロースプロジェクトとして継続的に関わらせていただき、「推し活倶楽部」においてもデザインや開発を担当いたしました。',
  },
  {
    text: '株式会社セブンネットショッピング営業本部 マーケティング＆プロモーション部から、統括マネージャー村上陽祐さん、スペシャリスト壁巣翔子さんをお迎えして、プロジェクトの概要とアイスリーデザインとの取り組みについての所感を伺いました。',
    nonMargin: true,
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'ユーザー体験の向上',
        text: 'エンタメ系ECサイトとして、ユーザーが楽しめる体験を提供し、サイトへの訪問理由や滞在時間の向上を図る必要がある。',
      },
      {
        title: 'UI/UXの最適化',
        text: '競合他社との差別化を図るために、サイトの使いやすさと見た目の魅力を向上させること。',
      },
      {
        title: 'コンバージョンレートの改善',
        text: 'エンターテインメント商品を特色とするセブンネットショッピングでのコンバージョン率向上。',
      },
    ],
    solutions: [
      {
        title: 'カスタマイズ可能なUI機能の導入',
        text: 'ユーザーが自分の好みに合わせてサイトの色を「推し色」に変更できる機能を導入し、個々のユーザー体験をパーソナライズ。',
      },
      {
        title: 'デザイン思考に基づいたUI/UX改善',
        text: 'ヒューリスティック評価を用いて、サイトの各要素を洗い出し、ユーザーにとってより使いやすく見た目にも魅力的なデザインへと改善。',
      },
      {
        title: 'データ駆動の改善プロセス',
        text: 'flamingoを用いたABテスト実施やユーザー分析を行い、改善効果を具体的に測定し、継続的なUI/UX改善を行うことで、CVRの向上を実現。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: '度重なるシステム改修、なくしませんか？',
  description:
    'システム改修不要のUI改善ツールとヒューリスティック評価・ABテストを組み合わせ、スピーディーかつデータ根拠のある継続改善をご支援します。まずは、現在の課題やお悩みをお聞かせください。',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
